module.exports = __webpack_public_path__ + "fonts/opensans-extrabolditalic.61ebb4bd.woff2";